import { Components } from '@mui/material'

import Colors from '#/styles/Colors'

export function OverridedDatePicker(): Components {
  return {
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          '& .Mui-selected': {
            color: '#fff !important',
          },
        },
      },
    },
    // era MuiPickersMonth.monthButton — componente e slot renomeados no MUI v6
    MuiMonthCalendar: {
      styleOverrides: {
        button: {
          textTransform: 'capitalize',
        },
      },
    },
    MuiPickerDay: {
      styleOverrides: {
        root: {
          // era slot 'daySelected' separado no MUI v5 — unificado em root com seletor CSS no v6
          '&.Mui-selected': {
            backgroundColor: Colors.theme.colors.primary.main,
          },
          // era slot 'day' no MUI v5, renomeado para root no v6
          'fontSize': '1em',
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          textTransform: 'capitalize',
        },
      },
    },
    MuiPickersInputBase: {
      styleOverrides: {
        root: {
          minHeight: 39,
        },
      },
    },
    // era MuiPickersBasePicker.pickerView — componente e slot renomeados no MUI v6
    MuiPickersLayout: {
      styleOverrides: {
        contentWrapper: {
          maxWidth: '100%',
        },
      },
    },
  }
}
